import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

/**
 * The schedule the user is currently looking at, per site — the single source of
 * truth shared across every schedule-aware surface (the Scheduler Gantt, the
 * Dashboard progress / master-schedule cards, the Activities list). Switching the
 * picker in the TopBar updates this so all of those surfaces move together.
 *
 * Runtime-only; persistence is handled separately by the per-site `lastViewed`
 * localStorage helper so a reload (or a direct landing on the Dashboard) restores
 * the last choice. A site with no entry here falls back to the most-recent
 * schedule at the read site (see `resolveActiveScheduleNumber`).
 */
export interface IActiveScheduleState {
  bySite: Record<string, string>;
}

const initialState: IActiveScheduleState = { bySite: {} };

const activeScheduleSlice = createSlice({
  name: 'activeSchedule',
  initialState,
  reducers: {
    setActiveSchedule(state, action: PayloadAction<{ siteId: string; scheduleNumber: string }>) {
      const { siteId, scheduleNumber } = action.payload;
      if (!siteId || !scheduleNumber) return;
      state.bySite[siteId] = scheduleNumber;
    },
  },
});

export const { setActiveSchedule } = activeScheduleSlice.actions;
export const activeScheduleReducer = activeScheduleSlice.reducer;
